<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormEntrada" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <nav>
                                <div class="nav nav-tabs" id="nav-tab2" role="tablist">
                                    <button type="button" class="nav-link active" id="nav-elementos-tab" data-bs-toggle="tab" data-bs-target="#nav-elementos" role="tab" aria-controls="nav-elementos" aria-selected="false">
                                        Elementos del Evento
                                    </button>
                                    <button type="button" class="nav-link" id="nav-herramientas-tab" data-bs-toggle="tab" data-bs-target="#nav-herramientas" role="tab" aria-controls="nav-herramientas" aria-selected="false">
                                        Herramientas
                                    </button>
                                    <button type="button" class="nav-link" id="nav-insumos-tab" data-bs-toggle="tab" data-bs-target="#nav-insumos" role="tab" aria-controls="nav-insumos" aria-selected="false">
                                        Insumos
                                    </button>
                                </div>
                            </nav>

                            <div class="tab-content" id="nav-tabContent">
                                <div class="tab-pane fade show active pt-3" id="nav-elementos" role="tabpanel" aria-labelledby="nav-elementos-tab">
                                    <div class="table-responsive" v-for="(Arreglo,key,ind) in ObjEntradas.ElementosGaleria" :key="ind">
                                        <h5>{{ 'Evento '+Arreglo[ind].cotizacion_evento.Evento }}</h5>
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th :class="StyleTh">Seleccionar</th>
                                                    <th :class="StyleTh">Nombre</th>
                                                    <th :class="StyleTh">Cantidad de Salida</th>
                                                    <th :class="StyleTh">Cantidad de Entrada</th>
                                                    <!-- <th :class="StyleTh">Estatus</th> -->
                                                    <th :class="StyleTh">Observaciones Salida</th>
                                                    <th :class="StyleTh">Observaciones Entrada</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item,index) in Arreglo" :key="index">
                                                    <td>
														{{(index+1)}}
													</td>
                                                    <td class="text-center">
                                                        <div class="form-check" v-show="item.SalidaCheck==1">
                                                            <input type="checkbox" v-model="item.Check" @change="SeleccionConcepto(item)" :id="'chk'+index" class="form-check-input">
                                                            <label class="form-check-label" :for="'chk'+index">
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td style="width:30%">
                                                        <textarea v-model="item.Nombre" class="form-control" rows="4" readonly></textarea>
                                                    </td>
                                                    <td class="text-center">
                                                        <p :class="StyleTd">{{ item.SalidaCheck==0 ? 'No Salió' : item.CantidadSalida }}</p>
                                                    </td>
                                                    <td>
                                                        <input :disabled="!item.Check" type="text" class="form-control" v-model="item.CantidadEntrada" @input="$onlyNums($event,item,'CantidadEntrada');CalculaStock(item)">
                                                    </td>
                                                    <!-- <td>
                                                        <select name="" id="" v-model="item.EstatusEntrada" class="form-control form-select">
                                                            <option value="">Seleccione una Opcion</option>
                                                            <option value="Completo">Completo</option>
                                                            <option value="Incompleto">Incompleto</option>
                                                        </select>
                                                    </td> -->
                                                    <td>
                                                        <textarea disabled name="" id="" cols="30" rows="4" v-model="item.ComentarioSalida" class="form-control"></textarea>
                                                    </td>
                                                    <td>
                                                        <textarea name="" id="" cols="30" rows="4" v-model="item.ComentarioEntrada" class="form-control"></textarea>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="tab-pane fade show" id="nav-herramientas" role="tabpanel" aria-labelledby="nav-herramientas-tab">
                                    <div class="table-responsive">
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th :class="StyleTh">Seleccionar</th>
                                                    <th :class="StyleTh">Nombre</th>
                                                    <th :class="StyleTh">Cantidad de Salida</th>
                                                    <th :class="StyleTh">Cantidad de Entrada</th>
                                                    <!-- <th :class="StyleTh">Estatus</th> -->
                                                    <th :class="StyleTh">Observaciones Salida</th>
                                                    <th :class="StyleTh">Observaciones Entrada</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item,index) in ObjEntradas.Herramientas" :key="index">
                                                    <td>
														{{(index+1)}}
													</td>
                                                    <td class="text-center">
                                                        <div class="form-check" v-show="item.SalidaCheck==1">
                                                            <input type="checkbox" v-model="item.Check" @change="SeleccionConcepto(item)" :id="'chkH'+index" class="form-check-input">
                                                            <label class="form-check-label" :for="'chkH'+index">
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td style="width:30%">
                                                        <h6 :class="StylePr">{{ item.Nombre }}</h6>
                                                    </td>
                                                    <td class="text-center"><p :class="StyleTd">{{ item.SalidaCheck==0 ? 'No Salió' : item.CantidadSalida }}</p></td>
                                                    <td>
                                                        <input :disabled="!item.Check" type="text" class="form-control" v-model="item.CantidadEntrada" @input="$onlyNums($event,item,'CantidadEntrada');CalculaStock(item)">
                                                    </td>
                                                    <!-- <td>
                                                        <select name="" id="" v-model="item.EstatusEntrada" class="form-control form-select">
                                                            <option value="">Seleccione una Opcion</option>
                                                            <option value="Completo">Completo</option>
                                                            <option value="Incompleto">Incompleto</option>
                                                        </select>
                                                    </td> -->
                                                    <td><textarea disabled name="" id="" cols="30" rows="4" v-model="item.ComentarioSalida" class="form-control"></textarea></td>
                                                    <td><textarea name="" id="" cols="30" rows="4" v-model="item.ComentarioEntrada" class="form-control"></textarea></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="tab-pane fade show" id="nav-insumos" role="tabpanel" aria-labelledby="nav-insumos-tab">
                                    <div class="table-responsive">
                                        <table class="table align-items-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th :class="StyleTh">Seleccionar</th>
                                                    <th :class="StyleTh">Nombre</th>
                                                    <th :class="StyleTh">Cantidad de Salida</th>
                                                    <th :class="StyleTh">Cantidad de Entrada</th>
                                                    <!-- <th :class="StyleTh">Estatus</th> -->
                                                    <th :class="StyleTh">Observaciones Salida</th>
                                                    <th :class="StyleTh">Observaciones Entrada</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item,index) in ObjEntradas.Insumos" :key="index">
                                                    <td>
														{{(index+1)}}
													</td>
                                                    <td class="text-center">
                                                        <div class="form-check" v-show="item.SalidaCheck==1">
                                                            <input type="checkbox" v-model="item.Check" @change="SeleccionConcepto(item)" :id="'chkI'+index" class="form-check-input">
                                                            <label class="form-check-label" :for="'chkI'+index">
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td style="width:30%">
                                                        <h6 :class="StylePr">{{ item.Nombre }}</h6>
                                                    </td>
                                                    <td class="text-center">
                                                        <p :class="StyleTd">{{ item.SalidaCheck==0 ? 'No Salió' : item.CantidadSalida }}</p>
                                                    </td>
                                                    <td class="text-center">
                                                        <input :disabled="!item.Check" type="text" class="form-control" v-model="item.CantidadEntrada" @input="$onlyNums($event,item,'CantidadEntrada');CalculaStock(item)">
                                                    </td>
                                                    <!-- <td>
                                                        <select name="" id="" v-model="item.EstatusEntrada" class="form-control form-select">
                                                            <option value="">Seleccione una Opcion</option>
                                                            <option value="Completo">Completo</option>
                                                            <option value="Incompleto">Incompleto</option>
                                                        </select>
                                                    </td> -->
                                                    <td><textarea disabled name="" id="" cols="30" rows="4" v-model="item.ComentarioSalida" class="form-control"></textarea></td>
                                                    <td><textarea name="" id="" cols="30" rows="4" v-model="item.ComentarioEntrada" class="form-control"></textarea></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
export default {
    name:'Entradas',
    props:['poBtnSave'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            ObjEntradas:{
                ElementosGaleria:[],
                Herramientas:[],
                Insumos:[]
            },
            ObjEvento:{},
            ObjSolicitudAlmacen:{},
            ListaCheckHerramientas:[],
            ListaCheckInsumos:[],
            ListaCheckGaleria:[],
            Emit: this.poBtnSave.EmitSeccion,
            errorvalidacion: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
        async Guardar()
        {
            let band1 = 0;
            let msg1 = '';
            let band2 = 0;
            let msg2 = '';
            let band3 = 0;
            let msg3 = '';

            $.each(this.ObjEntradas.ElementosGaleria, function(key, value){
                if((value.CantidadEntrada  < value.CantidadSalida) && value.ComentarioEntrada == '' && value.SalidaCheck >0){
                    msg1 = "Elementos: El campo observaciones de entrada de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
            });
            if(band1>0){ this.$toast.warning(msg1); return false; }

            $.each(this.ObjEntradas.Herramientas, function(key, value){
                if((value.CantidadEntrada  < value.CantidadSalida) && value.ComentarioEntrada == '' && value.SalidaCheck >0){
                    msg2 = "Herramientas: El campo observaciones de entrada de la partida: "+(key+1)+" no puede estar vacio";
                    band2++;
                    return false;
                }
            });
            if(band2>0){ this.$toast.warning(msg2); return false; }

            $.each(this.ObjEntradas.Insumos, function(key, value){
                if((value.CantidadEntrada  < value.CantidadSalida) && value.ComentarioEntrada == '' && value.SalidaCheck >0){
                    msg3 = "Isumos: El campo observaciones de entrada de la partida: "+(key+1)+" no puede estar vacio";
                    band3++;
                    return false;
                }
            });
            if(band3>0){ this.$toast.warning(msg3); return false; }

            let ElementosGaleria=[];
            for (const [Index,Elementos] of Object.entries(this.ObjEntradas.ElementosGaleria)) {
                Elementos.forEach(Elemento => {
                    ElementosGaleria.push(Elemento);
                });
            }

            let formData = new FormData();
            formData.set("ElementosGaleria",JSON.stringify(ElementosGaleria));
            formData.set("Herramientas",JSON.stringify(this.ObjEntradas.Herramientas));
            formData.set("Insumos",JSON.stringify(this.ObjEntradas.Insumos));
            formData.set("Estatus",'Finalizada');

            await this.$http.post('solicitudesAlmacenEntrada/'+this.ObjSolicitudAlmacen.IdSolicitudAlmacen,formData
            ).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            })
        },
        EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_seccionSolicitudAlmacen');
        },
        EjecutaConError(err)
        {
            // this.objHerramienta.Stock=this.objHerramienta.Cantidad;
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar()
        {
            this.$http.get('solicitudesAlmacenDetalles',{
                params:{
                    IdCotizacion: this.ObjEvento.IdCotizacion,
                    FechaEvento: this.ObjEvento.FechaEvento,
                    // SalidaCheck:1
                }
            }).then((res)=>{
                this.ObjSolicitudAlmacen = res.data.data.SolicitudAlmacen;
                // this.ObjEntradas.ElementosGaleria = res.data.data.DetallesCotizacion;
                this.ObjEntradas.ElementosGaleria=res.data.data.DetallesCotizacion.reduce((Resultado,Elemento)=>{
                    (Resultado[Elemento.IdCotizacionEvento] = Resultado[Elemento.IdCotizacionEvento] || []).push(Elemento);
                    return Resultado;
                },{});
                this.ObjEntradas.Herramientas = res.data.data.Herramientas;
                this.ObjEntradas.Insumos = res.data.data.Insumos;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            })
        },
        Limpiar(){

        },
        SeleccionConcepto(item)
        {
            if (item.Check) {
                item.EntradaCheck = 1;
            }
            else{
                item.EntradaCheck = 0;
            }
        },
        CalculaStock(item)
		{
			let Cantidad = item.CantidadEntrada;
			let Stock = item.CantidadSalida;

			if(Cantidad>Stock){
				item.CantidadEntrada = Stock;
			}
		},
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id,Obj)=>{
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
            this.ObjEvento=Obj;

            this.Recuperar();
            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>{
                this.Guardar();
            });
        });
    },
}
</script>

<style>

</style>